import { __decorate, __metadata } from "tslib";
import { Component, Model, Prop, Watch } from "vue-property-decorator";
import { UIComponent } from "../UIComponent";
import LvIcon from "../icon/LvIcon.vue";
import LvButton from "../button/LvButton.vue";
import LvField from "../field/LvField.vue";
import { LvButtonColor } from "../button";
export const COMPONENT_NAME = "LvNumberInput";
let LvNumberInput = class LvNumberInput extends UIComponent {
    constructor() {
        super(...arguments);
        this.innerValue = 0;
    }
    valueChanged(value) {
        let isValid = true;
        if (this.min != null && this.value < this.min) {
            isValid = false;
        }
        else if (this.max != null && this.value > this.max) {
            isValid = false;
        }
        if (isValid) {
            this.innerValue = value;
        }
        else {
            this.$emit("change", this.innerValue);
        }
    }
    innerValueChanged(innerValue) {
        let isValid = true;
        if (this.min != null && innerValue < this.min) {
            isValid = false;
        }
        else if (this.max != null && innerValue > this.max) {
            isValid = false;
        }
        if (isValid) {
            this.$emit("change", this.innerValue);
        }
        else {
            this.innerValue = this.value;
        }
    }
    mounted() {
        if (this.value !== undefined) {
            this.innerValue = this.value;
        }
    }
    get canSubstract() {
        return this.min == null || this.innerValue > this.min;
    }
    get canAdd() {
        return this.max == null || this.innerValue < this.max;
    }
    minus() {
        if (this.innerValue == null) {
            this.innerValue = 0;
        }
        if (this.min != null && this.innerValue <= this.min) {
            return;
        }
        --this.innerValue;
        this.$emit("change", this.innerValue);
    }
    plus() {
        if (this.innerValue == null) {
            this.innerValue = 0;
        }
        if (this.max != null && this.innerValue >= this.max) {
            return;
        }
        ++this.innerValue;
        this.$emit("change", this.innerValue);
    }
};
__decorate([
    Model("change", { type: Number, required: false, default: 0 }),
    __metadata("design:type", Number)
], LvNumberInput.prototype, "value", void 0);
__decorate([
    Prop({ type: Number, required: false, default: null }),
    __metadata("design:type", Number)
], LvNumberInput.prototype, "min", void 0);
__decorate([
    Prop({ type: Number, required: false, default: null }),
    __metadata("design:type", Number)
], LvNumberInput.prototype, "max", void 0);
__decorate([
    Prop({ type: String, required: false, default: "secondary" }),
    __metadata("design:type", Number)
], LvNumberInput.prototype, "color", void 0);
__decorate([
    Watch("value"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], LvNumberInput.prototype, "valueChanged", null);
__decorate([
    Watch("innerValue"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], LvNumberInput.prototype, "innerValueChanged", null);
LvNumberInput = __decorate([
    Component({
        name: COMPONENT_NAME,
        components: { LvField, LvButton, LvIcon },
    })
], LvNumberInput);
export default LvNumberInput;
//# sourceMappingURL=script.js.map